// Reserve legend rows plus a deliberate visual gap below x-axis labels.
// At 280px, the plot remains approximately as tall as the previous 260px
// chart while wrapped legend rows no longer crowd the date labels.
export const SPEND_CHART_LAYOUT = Object.freeze({
  height: 280,
  gridBottom: 120,
  legendBottom: 4,
});
